import css from "./homeslider.scss?inline";
import globalStyles from "../../index.scss?inline";
import { Component } from "../../utils/Component";
import { ArgSpecDictionary } from "../component-utils";

import swiperStyles from "../../../node_modules/swiper/swiper-bundle.min.css?inline";
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { HHDSModal } from "../Modal/Modal";
import { ModalController } from "../Modals/ModalController";

const DEBUG_VERBOSE: boolean = false;
const CLASS_NAME: string = "HHDSHomeSlider";
export const HHDSHomeSliderTagName: string = "hhds-home-slider";
const TAG_NAME: string = HHDSHomeSliderTagName;

// export const HHDSHomeSliderAttrNames = {
//   myNumericArg: "my-numeric-arg",
// };

// const Attrs = HHDSHomeSliderAttrNames;

export class HHDSHomeSlider extends Component {
	private _swiper: Swiper | null = null;
	private _prevButton: HTMLElement | null = null;
	private _nextButton: HTMLElement | null = null;

	private fullscreenBtnEl: HTMLElement | null = null;

	private slidesHTML: string = "";

	// private modalShowFunc: any;
	// private modalHideFunc: any;

	private numSlides: number = 0;

	constructor() {
		super();

		// this.modalShowFunc = (_event: Event) => {
		//   let modal = this.shadow.querySelector("hhds-modal") as HHDSModal;
		//   if (modal) {
		//     if (!modal.coordinator) {
		//       modal.createCoordinator();
		//     }
		//     this.updateModalVisibility(true, true);
		//   }
		// };

		// The base class's constructor handles attachmennt of a shadow root and
		// adopted global styles. Access the shadow root via this.shadow.
		//
		// Use the constructor only for anything that will never need to be destroyed as part of the
		// component's update lifecycle. init() and destroy() are called for connectedCallback and
		// disconnectedCallback, and a destroy() init() pair is called if reinit() is utilised.
	}

	protected override init(): void {
		// The base class responds to connectedCallback() by collecting attributes into
		// this.vars, then calling init(). A call to super.init() is not required.
		DEBUG_VERBOSE && console.log(CLASS_NAME, "init");

		// const argValue = this.vars.get<number>(Attrs.myNumericArg);

		// For some components, re-assigning innerHTML may be appropriate on attribute and slot changes,
		// and without the need for a reinit(). In other cases, assigning innerHTML explicitly as part of
		// the init() routine is more appropriate.
		this.shadow.innerHTML = `
      <style>${swiperStyles}</style>
      <style>${globalStyles}</style>
			<style>${css}</style>

      <div class="${TAG_NAME}">

        <div class="swiper">
          <div class="swiper-wrapper"></div>
          <div class="hhds-home-slider__button hhds-home-slider__button--prev">
            <hhds-icon type="directionleft" slot="start"></hhds-icon>
          </div>
          <div class="hhds-home-slider__button hhds-home-slider__button--next">
            <hhds-icon type="directionright" slot="start"></hhds-icon>
          </div>
        </div>

        <slot class="slides" style="display: none;"></slot>

        <div class="hhds-home-slider__content">
          <div class="container"> 
            <div class="grid">
              <div class="hhds-home-slider__tags col-span-4">
                <slot name="tags"></slot>
              </div>
              <div class="hhds-home-slider__controls col-span-4 col-start-11">
                <div class="hhds-home-slider__button hhds-home-slider__button--pagination"></div>
                  <div class="hhds-home-slider__button hhds-home-slider__button--fullscreen">
                    <hhds-icon type="fullscreen" slot="start"></hhds-icon>
                  </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      
      `;

		DEBUG_VERBOSE && console.log(CLASS_NAME, "Prev button: ", this._prevButton);
		DEBUG_VERBOSE && console.log(CLASS_NAME, "Next button: ", this._nextButton);

		this.copySlides();

		this.addListeners();

		requestAnimationFrame(() => {
			this.initSwiper();
			console.log("Swiper initialised", this._swiper?.slides);
		});

		const paginationEl = this.shadow.querySelector(
			".hhds-home-slider__button--pagination"
		) as HTMLElement;
		if (this.numSlides <= 1 && paginationEl) {
			paginationEl.style.display = "none";
		}

		// this.observeSlotChanges(true);
	}

	addListeners(): void {
		this.fullscreenBtnEl = this.shadow.querySelector(
			".hhds-home-slider__button--fullscreen"
		) as HTMLElement;
		this.fullscreenBtnEl?.addEventListener(
			"click",
			this.onFullscreenClick.bind(this)
		);
		// this.modalShowFunc);
	}

	onFullscreenClick(): void {
		this.toggleModal();
	}

	toggleModal(): void {
		const modal = ModalController.getInstance();
		modal.setContent(
			`<hhds-image-slider style="margin: 0 auto; --slider-max-height: var(--modal-max-height);">${this.slidesHTML}</hhds-image-slider>`
		);
		modal.open();
	}

	updateModalVisibility(visible: boolean, applyToModal: boolean): void {
		const modal = this.shadow.querySelector("hhds-modal") as HHDSModal;
		if (!modal) return;

		if (applyToModal) {
			if (visible) {
				modal.show();
			} else {
				modal.hide();
			}
		}
	}

	private initSwiper(): void {
		const swiperContainer = this.shadow.querySelector(".swiper") as HTMLElement;
		this._swiper = new Swiper(swiperContainer, {
			modules: [Navigation, Pagination, Autoplay, EffectFade],
			slideClass: "hhds-home-slider__slide",
			slidesPerView: 1,
			effect: "fade",
			autoplay: {
				disableOnInteraction: false,
			},
			loop: true,
			speed: 700,

			navigation: {
				nextEl: this.shadow.querySelector(
					".hhds-home-slider__button--next"
				) as HTMLElement,
				prevEl: this.shadow.querySelector(
					".hhds-home-slider__button--prev"
				) as HTMLElement,
			},

			pagination: {
				el: this.shadow.querySelector(
					".hhds-home-slider__button--pagination"
				) as HTMLElement,
				type: "fraction",
			},
		});
	}

	private copySlides() {
		const slidesEl = this.shadow?.querySelector(".slides");
		if (slidesEl && slidesEl instanceof HTMLSlotElement) {
			const swiperWrapperSelector = ".swiper-wrapper";
			const swiperWrapper = this.shadow?.querySelector(swiperWrapperSelector);

			if (!swiperWrapper)
				throw new Error(`Unable to derive selector: ${swiperWrapperSelector}`);

			const elements = slidesEl.assignedElements() as HTMLElement[];

			this.numSlides = elements.length;

			this.slidesHTML = "";

			elements.forEach((element) => {
				const slide = document.createElement("div");

				// Copy the images to the modal
				this.slidesHTML += element.outerHTML;

				slide.classList.add("hhds-home-slider__slide");
				slide.style.backgroundImage = `url(${element.getAttribute("src")})`;

				// slide.style.backgroundImage = `
				// linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 22.36%),
				// linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 0.50) 100%),
				// linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%),
				// url(${element.getAttribute("src")})`;

				swiperWrapper.appendChild(slide);
			});
		}
	}

	protected override destroy(): void {
		// The base class responds to disconnectedCallback() by collecting attributes into
		// this.vars, then calling destroy(). A call to super.destroy() is not required.
		DEBUG_VERBOSE && console.log(CLASS_NAME, "destroy");
		// If the component uses slots, stop observing slot changes.
		// this.observeSlotChanges(false);
	}

	override onAttributeChanged(
		name: string,
		_oldValue: string,
		newValue: string
	): void {
		DEBUG_VERBOSE &&
			console.log(CLASS_NAME, "Attribute changed: ", name, _oldValue, newValue);
		// Either call reinit() to have the component's destroy and init methods each be called,
		// or skip this step and handle update of the attribute directly. 'this.vars' will already
		// have been updated by the base Component class, so it can be immediately used to access
		// the new value.
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, elements: Element[]): void {
		if (elements.length == 0) {
			DEBUG_VERBOSE && console.log(CLASS_NAME, "Slot emptied");
		} else {
			DEBUG_VERBOSE && console.log(CLASS_NAME, "Slot changed");
		}
	}

	static override argSpecs(): ArgSpecDictionary {
		// The base Component class must have access to this superclass's ArgSpecs.
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	/*my-enum: {
    description: "Some enum-based argument.",
    defaultValue: MyEnum.myValue,
    typeString: "MyEnum",
    type: MyEnum,
  },*/
	// [Attrs.myNumericArg]: {
	//   description: "An argument to demonstrate the typed args system.",
	//   defaultValue: 42,
	//   //category: "General",
	//   type: Number,
	// },
};
